import { getBezierPath, useInternalNode } from '@xyflow/react';

import { getEdgeParams } from '../utils/initialElements';
import { ExtendedNode } from './types';

export type FloatingEdgeProps = {
  id: string;
  source: string;
  target: string;
  markerEnd?: string;
  style?: React.CSSProperties;
};

export const FloatingEdge: React.FC<FloatingEdgeProps> = ({
  id,
  source,
  target,
  markerEnd,
  style,
}) => {
  const sourceNode = useInternalNode(source);
  const targetNode = useInternalNode(target);

  if (!sourceNode || !targetNode) {
    return null;
  }

  function safeExtendNode(node: any): ExtendedNode {
    return {
      ...node,
      measured: {
        width: node.measured?.width ?? 0,
        height: node.measured?.height ?? 0,
      },
      internals: {
        positionAbsolute: node.internals?.positionAbsolute ?? { x: 0, y: 0 },
      },
    };
  }

  const safeSourceNode: ExtendedNode = safeExtendNode(sourceNode);
  const safeTargetNode: ExtendedNode = safeExtendNode(targetNode);

  const { sx, sy, tx, ty, sourcePos, targetPos } = getEdgeParams(
    safeSourceNode,
    safeTargetNode
  );

  const [edgePath] = getBezierPath({
    sourceX: sx,
    sourceY: sy,
    sourcePosition: sourcePos,
    targetPosition: targetPos,
    targetX: tx,
    targetY: ty,
  });

  return (
    <path
      id={id}
      className="react-flow__edge-path"
      d={edgePath}
      markerEnd={markerEnd}
      style={style}
    />
  );
};
